// extracted by mini-css-extract-plugin
module.exports = {"field":"ImagesAndCTA_field__SzCHj"};